module.exports = __webpack_public_path__ + "img/adela-livio-small.f1aacd6f.jpg";